export const PLAN_ORDER = ["free", "starter", "professional", "enterprise"];

// Nombres de `agencies/plans.py`, para respuestas que solo traen el id del plan
export const PLAN_NAMES = {
  trial: "Prueba gratuita",
  free: "Free",
  starter: "Starter",
  professional: "Professional",
  enterprise: "Enterprise",
};

// > 0 if `target` is above `current`, < 0 if below, 0 if equal or unknown.
export const comparePlans = (current, target) => {
  const a = PLAN_ORDER.indexOf(current);
  const b = PLAN_ORDER.indexOf(target);
  if (a === -1 || b === -1) return 0;
  return b - a;
};

// Aviso que merece una suscripción (plan o `seats`); el impago manda sobre la cancelación.
export const billingStatus = (subscription) => {
  if (subscription.past_due) return "past_due";
  if (subscription.cancel_at_period_end) return "cancelling";
  if (subscription.downgrade_at_period_end) return "downgrading";
  return null;
};

// `price` = { amount (céntimos), currency } o null.
export const formatPrice = (price) => {
  if (!price || typeof price.amount !== "number") return null;
  const value = price.amount / 100;
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: (price.currency || "eur").toUpperCase(),
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(value);
};

const parseDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const dateFormatter = (options) => (value) => parseDate(value)?.toLocaleDateString("es-ES", options) ?? "";

export const formatDate = dateFormatter({ day: "numeric", month: "long", year: "numeric" });

export const formatShortDate = dateFormatter({ day: "numeric", month: "short" });

const shortDateWithYear = dateFormatter({ day: "numeric", month: "short", year: "numeric" });

// "1 ene 2027"
export const formatShortDateWithYear = (value) => shortDateWithYear(value).replace(".", "");

export const daysUntil = (value) => {
  const date = parseDate(value);
  return date ? Math.ceil((date.getTime() - Date.now()) / 86400000) : null;
};

export const pluralize = (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;

// Siempre con dos decimales, para desgloses: 99 -> "99,00 €"
export const formatExactPrice = (price) => {
  if (!price || typeof price.amount !== "number") return null;
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: (price.currency || "eur").toUpperCase(),
    minimumFractionDigits: 2,
  }).format(price.amount / 100);
};

export const scalePrice = (price, factor) => (price ? { ...price, amount: Math.round(price.amount * factor) } : null);

// Precio de las horas: `{ currency, packs: [{ hours, amount }] }`, un bono por cantidad (1–6 h).
export const hoursPackPrice = (price, hours) => ({
  amount: price.packs.find((pack) => pack.hours === hours).amount,
  currency: price.currency,
});

export const lowestHourPrice = (price) => {
  const pack = price.packs.at(-1);
  return { amount: Math.round(pack.amount / pack.hours), currency: price.currency };
};
